const ResourceType = Object.freeze({
  Normal: 'Normal',
  SubResource: 'SubResource',
  ResourceGroup: 'ResourceGroup',
})

export default ResourceType

export const resourceTypes = [
  ResourceType.Normal,
  ResourceType.SubResource,
  ResourceType.ResourceGroup,
]
